export default __webpack_public_path__ + "static/media/Malaki_Store.3fdaed29.jpg";